import { render } from "./BlogDetailsPage.vue?vue&type=template&id=4e2ad114"
import script from "./BlogDetailsPage.vue?vue&type=script&lang=js"
export * from "./BlogDetailsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__